import React from 'react'
import {easeQuadInOut} from 'd3-ease'
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

import AnimatedProgressProvider from './animated-progress-provider'

export interface IStat {
  title?: string,
  footer?: string,
  valueStart: number,
  valueEnd: number,
  actualEnd?: number,
  isTextStatic?: boolean,
  staticPrefix?: string,
  staticSuffix?: string,
  numDecimalPlaces?: number,
  isStatTime?: boolean,
  trailColor?: string,
  roundUp?: boolean,
}

interface ITopLineStat {
  className?: string,
  stat: IStat,
  index: number,
  animationDuration?: number,
  animationDelay?: number,
  textColor?: string,
}

const ToplineStat: React.FunctionComponent<ITopLineStat> = ({
  className = '',
  stat,
  index,
  animationDelay = 500,
  animationDuration = 2000,
  textColor = 'white',
}) => {
  const {
    title = '',
    valueStart,
    valueEnd,
    actualEnd = valueEnd,
    isTextStatic = false,
    staticPrefix = '',
    staticSuffix = '',
    numDecimalPlaces = 0,
    isStatTime = false,
    footer = '',
    trailColor = '#d6d6d6',
    roundUp = false,
  } = stat

  return (
    <div className={className}>
      <h4 style={{whiteSpace: 'pre-line'}}>{title}</h4>

      <AnimatedProgressProvider
        valueStart={valueStart}
        valueEnd={actualEnd}
        duration={animationDuration + (animationDelay * index)}
        easingFunction={easeQuadInOut}
      >
        {(value) => {
          const roundedValue = roundUp ? Math.ceil(value) : Math.round(value * (10 ** numDecimalPlaces)) / (10 ** numDecimalPlaces)
          let textValue
          // TODO:(kyle) refactor how time animates when minutes change e.g. 0:59 -> 1:00
          if (isStatTime && roundedValue < 10) {
            textValue = `0${roundedValue}`
          } else {
            textValue = roundedValue
          }
          return (
            <CircularProgressbar
              className='col-10 col-md-8'
              value={value}
              minValue={valueStart}
              maxValue={valueEnd}
              text={isTextStatic
                ? `${staticPrefix}${valueEnd}${staticSuffix}`
                : `${staticPrefix}${textValue}${staticSuffix}`
              }
              strokeWidth={12}
              styles={buildStyles({
                pathTransition: 'none',
                pathColor: `rgba(173, 80, 255, ${value / actualEnd})`,
                textColor: `${textColor}`,
                trailColor: `${trailColor}`,
              })}
            />
          )
        }}
      </AnimatedProgressProvider>
      <p style={{whiteSpace: 'pre-line', marginTop: '1em'}}>{footer}</p>
    </div>
  )
}

export default ToplineStat
